// extracted by mini-css-extract-plugin
export var arrow = "Footer-module--arrow--15014";
export var arrowNo = "Footer-module--arrow_no--b64c9";
export var arrowYes = "Footer-module--arrow_yes--36c72";
export var centeredFooterSection = "Footer-module--centeredFooterSection--d58bf";
export var contentContainer = "Footer-module--contentContainer--39f82";
export var firstDivider = "Footer-module--firstDivider--d2771";
export var flex = "Footer-module--flex--cc9fb";
export var flex1 = "Footer-module--flex_1--4fcb4";
export var flexCenter = "Footer-module--flex_center--f7a3d";
export var flexCenterCol = "Footer-module--flex_center_col--2a05a";
export var flexCol = "Footer-module--flex_col--151aa";
export var flexFixCenterCol = "Footer-module--flex_fix_center_col--034a5";
export var flexFixedCenterCol = "Footer-module--flex_fixed_center_col--d8dce";
export var footerLogoSection = "Footer-module--footerLogoSection--8c132";
export var footerNavigationWrapper = "Footer-module--footerNavigationWrapper--dad84";
export var footerWrapper = "Footer-module--footerWrapper--3ca52";
export var iycfText = "Footer-module--iycfText--38216";
export var logo = "Footer-module--logo--788c5";
export var logoTitle = "Footer-module--logoTitle--af961";
export var logoWrapper = "Footer-module--logoWrapper--868f6";
export var navigationItem = "Footer-module--navigationItem--ff51c";
export var navigationItemTitle = "Footer-module--navigationItemTitle--48cec";
export var padded = "Footer-module--padded--193a2";
export var partnerDisclaimer = "Footer-module--partnerDisclaimer--7b65b";
export var partnersWithText = "Footer-module--partnersWithText--26813";
export var providerText = "Footer-module--providerText--d3c47";
export var providerTextWrapper = "Footer-module--providerTextWrapper--e4273";
export var rotating = "Footer-module--rotating--5cf0b";
export var sectionDivider = "Footer-module--sectionDivider--cdd35";
export var sponsorLogo = "Footer-module--sponsorLogo--cda8b";
export var sponsorLogoRow = "Footer-module--sponsorLogoRow--60db6";
export var sponsorLogoWrapper = "Footer-module--sponsorLogoWrapper--0d5d8";
export var usaidIcon = "Footer-module--usaidIcon--3f54f";